import React from 'react';
import { PlusOutlined, ReloadOutlined } from '@ant-design/icons';
import type { ButtonConfig } from '@ms/shared-components';
import { SpaceType, Space } from '../../../types/space';

/**
 * 树操作菜单项配置
 */
export const treeMenuItems = [
  { key: 'view', label: '查看详情' },
  { key: 'edit', label: '编辑' },
  { key: 'addChild', label: '新建子空间' },
  { key: 'delete', label: '删除' }
];

/**
 * 根据空间类型和是否来自酒店获取菜单项
 * SPACE 类型（第三级，最后一层）不显示"新建子空间"选项
 * 来自酒店的节点不显示"编辑"和"删除"选项
 */
export const getMenuItemsBySpaceType = (space: Space | { type?: SpaceType; fromHotel?: boolean }) => {
  const spaceType = 'type' in space ? space.type : undefined;
  const fromHotel = 'fromHotel' in space ? space.fromHotel : false;
  
  let items = [...treeMenuItems];
  
  // SPACE 类型是最后一层，不能添加子空间
  if (spaceType === SpaceType.SPACE) {
    items = items.filter(item => item.key !== 'addChild');
  }
  
  // 来自酒店的节点不显示编辑和删除选项
  if (fromHotel === true) {
    items = items.filter(item => item.key !== 'edit' && item.key !== 'delete');
  }
  
  return items;
};

/**
 * 树面板按钮配置
 */
export const createTreeButtons = (handlers: {
  handleCreate: () => void;
  handleRefresh: () => void;
}): ButtonConfig[] => [
    {
      key: 'refresh',
      text: '刷新',
      icon: React.createElement(ReloadOutlined),
      onClick: handlers.handleRefresh,
      group: 'primary',
    },
    {
      key: 'create',
      text: '新建建筑',
      icon: React.createElement(PlusOutlined),
      type: 'primary',
      onClick: handlers.handleCreate,
      group: 'primary',
    },
  ];